import { inject } from 'vue';

import locales from '@components/locale';
import { isObject, propsFactory, warn } from '@components/utils';

import type { ILocale, TAvailableLocale } from '@components/locale';
import type { InjectionKey, PropType } from 'vue';

const DEFAULT_LOCALE = 'ru';

export interface ILocaleProps {
  locale?: ILocale | TAvailableLocale;
}

export const LocaleSymbol: InjectionKey<TAvailableLocale | ILocale> = Symbol.for('cds:locale');

export const makeLocaleProps = propsFactory(
  {
    /**
     * Локализация компонента
     */
    locale: {
      type: [Object, String] as PropType<TAvailableLocale | ILocale>,
      default: undefined
    }
  },
  'locale'
);

export function useLocale(props: ILocaleProps): ILocale {
  const locale = props.locale || inject(LocaleSymbol);

  if (isObject(locale)) {
    return { ...locales[DEFAULT_LOCALE], ...locale } as ILocale;
  }

  if (!locales[locale as TAvailableLocale]) {
    warn('locale', `Locale "${locale}" is not available. Use "${DEFAULT_LOCALE}" locale instead.`);
    return locales[DEFAULT_LOCALE];
  }

  return { ...locales[locale as TAvailableLocale] };
}
